import { render } from "./application.vue?vue&type=template&id=5bc2e07e&scoped=true"
import script from "./application.vue?vue&type=script&lang=js"
export * from "./application.vue?vue&type=script&lang=js"

import "./application.vue?vue&type=style&index=0&id=5bc2e07e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5bc2e07e"

export default script